import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/SubjectCategoryPage.css';
import { FaArrowLeft } from 'react-icons/fa';
import { API_URL } from '../config';

const AdminSubjectCategoryPage = () => {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const fetchCategories = useCallback(() => {
    axios.get(`${API_URL}/admin/subjectcategory/`)
      .then(response => setCategories(response.data))
      .catch(error => console.error('Error fetching categories:', error));
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const handleSubmit = () => {
    if (!name.trim()) {
      alert('Category name is required!');
      return;
    }

    setLoading(true);

    if (editMode) {
      // Edit category
      axios.put(`${API_URL}/admin/subjectcategory/${editId}/`, { name })
        .then(() => {
          fetchCategories();
          resetForm();
        })
        .catch(error => {
          console.error('Error updating category:', error);
          alert('Failed to update category');
        })
        .finally(() => setLoading(false));
    } else {
      // Create category
      axios.post(`${API_URL}/admin/subjectcategory/`, { name })
        .then(response => {
          setCategories([...categories, response.data]);
          setName('');
        })
        .catch(error => console.error('Error creating category:', error))
        .finally(() => setLoading(false));
    }
  };

  const handleEdit = (category) => {
    setEditMode(true);
    setEditId(category.id);
    setName(category.name);
  };

  const cancelEdit = () => {
    resetForm();
  };

  const resetForm = () => {
    setEditMode(false);
    setEditId(null);
    setName('');
  };

  const deleteCategory = (id) => {
    if (window.confirm('Are you sure you want to delete this category?')) {
      axios.delete(`${API_URL}/admin/subjectcategory/${id}/`)
        .then(() => {
          const updatedCategories = categories.filter(category => category.id !== id);
          setCategories(updatedCategories);
        })
        .catch(error => console.error('Error deleting category:', error));
    }
  };

  return (
    <div className="admin-container">
      <button onClick={() => navigate(-1)} className="back-button">
        <FaArrowLeft className="white-arrow" /> Back
      </button>
      <h1>Subject Categories</h1>

      {/* Create/Edit Form */}
      <div className="form-group">
        <input
          type="text"
          placeholder="Enter category name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="text-input"
        />
        <div className="form-actions">
          <button onClick={handleSubmit} className='subj-button' disabled={loading}>
            {editMode ? 'Update Category' : 'Create Category'}
          </button>
          {editMode && (
            <button onClick={cancelEdit} className="subjcancel-button">
              Cancel
            </button>
          )}
        </div>
      </div>

      {/* List of Categories */}
      <div className="category-list">
        {categories.map((item) => (
          <div key={item.id} className="category-item">
            <div className="category-name">{item.name}</div>
            <div className="category-actions">
              <button onClick={() => handleEdit(item)} className="edit-button">Edit</button>
              <button onClick={() => deleteCategory(item.id)} className="delete-button">Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminSubjectCategoryPage;
